import React, { ReactNode, useEffect } from "react";
import { Provider } from "react-redux";
import configStore, { EisenhowerContext } from "./eisenhowerStore";
import { requestStatusFromServer } from "./msgs/edgeMsgSender";

interface IProps {
    appID?: string;
    children: ReactNode;
}

function EisenhowerProvider(props: IProps) {
    useEffect(() => {
        requestStatusFromServer();
    }, []);

    return (
        <Provider store={configStore} context={EisenhowerContext}>
            {props.children}
        </Provider>
    );
}

export default EisenhowerProvider;
